/**
 * Runtime config for the Pages SPA (WP24).
 * No secrets — Access JWT is browser-provided via CF Access.
 */

/** API origin, e.g. https://api.example.com — empty/relative uses same origin (+ Vite proxy in dev). */
export function getApiBaseUrl(): string {
  const raw = import.meta.env.VITE_API_BASE_URL?.trim() ?? "";
  if (!raw || raw === "/") return "";
  return raw.replace(/\/$/, "");
}
